// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"52bd3714","787":"99935196"}[chunkId] + ".chunk.js";
};